import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ProgressModule } from '../progress/progress.module';

@NgModule({
  imports: [CommonModule, SvgIconModule, ProgressModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent],
})
export class ButtonModule {}
